module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_02-d4cbdebd11824587a357af2fd7a752dc.png";